import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, ArrowRight, Landmark } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export default function GovtHealthList() {
  const [hubs, setHubs] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/hubs").then(({ data }) => setHubs(data)); }, []);

  return (
    <div className="px-4 py-4 pb-8">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600"><Landmark className="h-5 w-5" /></span>
        <div>
          <h1 className="font-heading text-xl font-extrabold text-slate-900">Government & Health</h1>
          <p className="text-xs text-slate-500">Official hubs — Information, Discussion, Updates, Opportunities & Connect</p>
        </div>
      </div>
      <div className="space-y-4">
        {hubs === null && [1, 2, 3].map((i) => <Skeleton key={i} className="h-40 w-full rounded-2xl" />)}
        {hubs && hubs.map((h) => (
          <button key={h.slug} data-testid={`hub-card-${h.slug}`} onClick={() => navigate(`/govt-health/${h.slug}`)}
            className="ml-rise block w-full overflow-hidden rounded-2xl border border-slate-200 bg-white text-left shadow-sm transition-colors hover:border-indigo-300">
            {h.image_url && <img src={fileUrl(h.image_url)} alt="" className="h-28 w-full object-cover" />}
            <div className="p-4">
              <div className="flex items-center gap-2">
                <Building2 className="h-4 w-4 text-indigo-600" />
                <h3 className="font-heading text-base font-bold text-slate-900">{h.name}</h3>
              </div>
              <p className="mt-1 line-clamp-2 text-sm text-slate-600">{h.short_desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-indigo-600">Open hub <ArrowRight className="h-4 w-4" /></span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
